export const snackbar = {
  namespaced: true,
  state: {
    visible: false,
    content: "",
    color: ""
  },
  actions: {
    show({ commit }, payload) {
      commit("show", payload);
    }
  },
  mutations: {
    show(state, payload) {
      state.content = payload.content;
      state.color = payload.color;
      state.visible = true;
      setTimeout(() => {
        state.visible = false;
      }, 2000);
    }
  }
};
